/* =============================================
   WIZARD MAGIC SHOP — Magical JS Enhancements
   ============================================= */

(function () {
  'use strict';

  /* ---- SPARKLE CURSOR EFFECT ---- */
  var sparkleColors = ['#c4b5fd', '#f0abfc', '#fcd34d', '#a78bfa', '#e879f9', '#fff'];
  var lastSparkle = 0;

  function createSparkle(x, y) {
    var now = Date.now();
    if (now - lastSparkle < 60) return; // throttle to ~16fps
    lastSparkle = now;

    for (var i = 0; i < 3; i++) {
      var el = document.createElement('div');
      el.className = 'wizard-sparkle';
      var size = Math.random() * 6 + 3;
      var color = sparkleColors[Math.floor(Math.random() * sparkleColors.length)];
      var offsetX = (Math.random() - 0.5) * 30;
      var offsetY = (Math.random() - 0.5) * 30;
      el.style.cssText = [
        'width:' + size + 'px',
        'height:' + size + 'px',
        'background:' + color,
        'left:' + (x + offsetX) + 'px',
        'top:' + (y + offsetY) + 'px',
        'animation-duration:' + (Math.random() * 0.4 + 0.5) + 's'
      ].join(';');
      document.body.appendChild(el);
      setTimeout(function (node) { node.remove(); }, 900, el);
    }
  }

  // Only on desktop to avoid battery drain on mobile
  if (window.matchMedia('(pointer: fine)').matches) {
    document.addEventListener('mousemove', function (e) {
      createSparkle(e.clientX, e.clientY);
    }, { passive: true });
  }

  /* ---- TRUST BADGES STRIP ---- */
  function insertTrustBadges() {
    // Insert after the header, before main content
    var header = document.querySelector('#shopify-section-header');
    if (!header || document.getElementById('wizard-trust-strip')) return;

    var strip = document.createElement('div');
    strip.id = 'wizard-trust-strip';
    strip.className = 'wizard-trust-badges';
    strip.setAttribute('aria-label', 'Store trust badges');
    strip.innerHTML = [
      badge('M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z', '100% Secure Checkout'),
      badge('M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z', 'Encrypted Payments'),
      badge('M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z', 'Free US Shipping $100+'),
      badge('M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z', 'Easy Returns'),
      badge('M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z', 'Trusted by Magicians')
    ].join('');

    header.insertAdjacentElement('afterend', strip);
  }

  function badge(path, label) {
    return '<div class="wizard-trust-badge" aria-label="' + label + '">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + path + '"></path></svg>' +
      '<span>' + label + '</span>' +
      '</div>';
  }

  /* ---- FLOATING STARS ON HERO/SLIDESHOW ---- */
  function addFloatingStars() {
    var slideshow = document.querySelector('.slideshow');
    if (!slideshow || slideshow.querySelector('.wizard-star')) return;
    slideshow.style.position = 'relative';
    slideshow.style.overflow = 'hidden';

    var starChars = ['✦', '✧', '⋆', '★', '✩', '✶'];
    for (var i = 0; i < 12; i++) {
      (function (idx) {
        var star = document.createElement('div');
        star.className = 'wizard-star';
        star.textContent = starChars[idx % starChars.length];
        star.style.left = (Math.random() * 100) + '%';
        star.style.animationDuration = (Math.random() * 8 + 6) + 's';
        star.style.animationDelay = (Math.random() * 8) + 's';
        star.style.fontSize = (Math.random() * 14 + 8) + 'px';
        slideshow.appendChild(star);
      })(i);
    }
  }

  /* ---- PRODUCT PAGE: SCROLL-TO-REVIEWS LINK ---- */
  function addReviewScrollLink() {
    var ratingBlock = document.querySelector('.product__title + * .rating, .product .rating-wrapper');
    if (!ratingBlock) return;
    var reviewSection = document.querySelector('[id*="yotpo"], .yotpo-reviews-main, .shopify-reviews');
    if (!reviewSection) return;

    ratingBlock.style.cursor = 'pointer';
    ratingBlock.title = 'Read all reviews';
    ratingBlock.addEventListener('click', function () {
      reviewSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ---- BACK TO TOP BUTTON ---- */
  function initBackToTop() {
    if (document.getElementById('wizard-back-top')) return;
    var btn = document.createElement('button');
    btn.id = 'wizard-back-top';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"></polyline></svg>';
    btn.style.cssText = [
      'position:fixed',
      'bottom:24px',
      'right:24px',
      'z-index:500',
      'width:44px',
      'height:44px',
      'border-radius:50%',
      'background:linear-gradient(135deg,#6a0dad,#9333ea)',
      'color:#fff',
      'border:none',
      'cursor:pointer',
      'display:flex',
      'align-items:center',
      'justify-content:center',
      'box-shadow:0 4px 16px rgba(106,13,173,0.35)',
      'opacity:0',
      'transform:translateY(10px)',
      'transition:opacity 0.3s ease,transform 0.3s ease',
      'pointer-events:none'
    ].join(';');

    document.body.appendChild(btn);

    window.addEventListener('scroll', function () {
      var visible = window.scrollY > 400;
      btn.style.opacity = visible ? '1' : '0';
      btn.style.transform = visible ? 'translateY(0)' : 'translateY(10px)';
      btn.style.pointerEvents = visible ? 'auto' : 'none';
    }, { passive: true });

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ---- EXIT-INTENT POPUP ---- */
  function initExitPopup() {
    var STORAGE_KEY = 'wms_popup_seen';

    // Skip on cart / checkout pages — never interrupt a purchase
    var path = window.location.pathname;
    if (path.indexOf('/cart') === 0 || path.indexOf('/checkout') === 0) return;

    // Don't show if already seen — ever (one time per device, permanently)
    if (localStorage.getItem(STORAGE_KEY)) return;

    function showPopup() {
      if (document.getElementById('wizard-exit-popup')) return;

      var overlay = document.createElement('div');
      overlay.className = 'wizard-popup-overlay';
      overlay.id = 'wizard-exit-popup';
      overlay.innerHTML = [
        '<div class="wizard-popup" role="dialog" aria-modal="true" aria-label="Special offer">',
          '<button class="wizard-popup__close" aria-label="Close">&times;</button>',
          '<div class="wizard-popup__emoji">🪄</div>',
          '<h2 class="wizard-popup__title">Wait — Before You Go!</h2>',
          '<p class="wizard-popup__sub">Join our magic community and get exclusive deals,<br>new arrivals & tricks straight to your inbox.</p>',
          '<form class="wizard-popup__form" id="wizard-popup-form">',
            '<input class="wizard-popup__input" type="email" placeholder="Your email address" required aria-label="Email address">',
            '<button class="wizard-popup__btn" type="submit">Get Deals 🎩</button>',
          '</form>',
          '<button class="wizard-popup__skip">No thanks, I\'ll pay full price</button>',
        '</div>'
      ].join('');

      document.body.appendChild(overlay);
      localStorage.setItem(STORAGE_KEY, Date.now().toString());

      // Close on overlay click / close btn / skip
      function close() {
        overlay.style.opacity = '0';
        overlay.style.transition = 'opacity 0.25s';
        setTimeout(function() { overlay.remove(); }, 260);
      }

      overlay.querySelector('.wizard-popup__close').addEventListener('click', close);
      overlay.querySelector('.wizard-popup__skip').addEventListener('click', close);
      overlay.addEventListener('click', function(e) { if (e.target === overlay) close(); });

      // Form submit → show success
      overlay.querySelector('#wizard-popup-form').addEventListener('submit', function(e) {
        e.preventDefault();
        var email = this.querySelector('input[type="email"]').value;
        this.innerHTML = '<p class="wizard-popup__success">✅ You\'re in! Check your inbox for magic. 🎩</p>';
        fetch('/contact', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: 'form_type=customer&email=' + encodeURIComponent(email) + '&tags=exit-popup'
        });
        setTimeout(close, 2800);
      });
    }

    // Only trigger on true exit intent — mouse heading to browser bar (desktop only)
    // No timer: we never interrupt a customer who is actively browsing
    if (window.matchMedia('(pointer: fine)').matches) {
      document.addEventListener('mouseleave', function onLeave(e) {
        if (e.clientY <= 5) {
          document.removeEventListener('mouseleave', onLeave);
          showPopup();
        }
      });
    }
  }

  /* ---- STICKY ANNOUNCEMENT BAR HEIGHT ---- */
  function initStickyAnnouncement() {
    var bar = document.querySelector('.announcement-bar-section');
    if (!bar) return;

    function setHeight() {
      document.documentElement.style.setProperty(
        '--announcement-bar-height',
        bar.offsetHeight + 'px'
      );
    }

    setHeight();
    window.addEventListener('resize', setHeight, { passive: true });
  }

  /* ---- PRODUCT VIDEO LOADING INDICATOR + SMART PRELOAD ---- */
  function initLazyVideos() {
    var videos = document.querySelectorAll('.mms_prod_video, .product__description video, .product-description video');
    if (!videos.length) return;

    videos.forEach(function(v) {
      // Start with metadata only (fast page load — just duration/dimensions)
      v.setAttribute('preload', 'metadata');
      // playsinline prevents iOS from forcing full-screen before playback starts
      v.setAttribute('playsinline', '');

      // Smart preload: upgrade to 'auto' when video scrolls within 400px of viewport
      // so by the time customer scrolls to it, it's already buffered
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              entry.target.setAttribute('preload', 'auto');
              observer.unobserve(entry.target);
            }
          });
        }, { rootMargin: '400px' });
        observer.observe(v);
      }

      // Wrap in relative container for the overlay
      var wrapper = document.createElement('div');
      wrapper.style.cssText = 'position:relative;display:block;width:100%;';
      v.parentNode.insertBefore(wrapper, v);
      wrapper.appendChild(v);

      // Loading spinner overlay — shown while buffering after play is pressed
      var overlay = document.createElement('div');
      overlay.className = 'wizard-video-loading';
      overlay.innerHTML = '<div class="wizard-video-spinner"></div><p>Loading video…</p>';
      overlay.style.display = 'none';
      wrapper.appendChild(overlay);

      // Show spinner only if customer presses play before buffer is ready
      v.addEventListener('play', function() {
        if (v.readyState < 3) overlay.style.display = 'flex';
      });
      v.addEventListener('waiting', function() { overlay.style.display = 'flex'; });
      v.addEventListener('playing', function() { overlay.style.display = 'none'; });
      v.addEventListener('canplay', function() { overlay.style.display = 'none'; });
    });
  }

  /* ---- AUTO-DISMISS PRIVACY BANNER ---- */
  function initPrivacyBanner() {
    function acceptAndHide() {
      // Use Shopify's own consent API to accept all — this properly records consent
      // and prevents the banner from ever appearing again
      if (window.Shopify && window.Shopify.customerPrivacy) {
        try {
          window.Shopify.customerPrivacy.setTrackingConsent(
            { marketing: true, analytics: true, preferences: true, sale_of_data: true },
            function() {}
          );
        } catch(e) {}
      }
      // Also hide via CSS immediately in case the API call is async
      var style = document.createElement('style');
      style.textContent = '[class*="shopify-pc__banner"],[class*="shopify-pc__prefs"]{display:none!important}';
      document.head.appendChild(style);
    }

    // Run immediately if API is already loaded, otherwise wait for it
    if (window.Shopify && window.Shopify.customerPrivacy) {
      acceptAndHide();
    } else {
      document.addEventListener('trackingConsentAccepted', acceptAndHide);
      // Fallback: hide banner visually after short delay if API never fires
      setTimeout(function() {
        var banner = document.querySelector('[class*="shopify-pc__banner"]');
        if (banner) acceptAndHide();
      }, 800);
    }
  }

  /* ---- INIT ---- */
  function init() {
    insertTrustBadges();
    addFloatingStars();
    initBackToTop();
    addReviewScrollLink();
    initStickyAnnouncement();
    initExitPopup();
    initLazyVideos();
    initPrivacyBanner();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run after Shopify section renders (theme editor)
  document.addEventListener('shopify:section:load', init);

})();
